/**
 * Enumeration for the checklist item category.
 *
 * @readonly
 * @enum {string}
 */
export const ChecklistItemCategory = {
    INTERNAL: 'INTERNAL',
    EXTERNAL: 'EXTERNAL'
}

Object.freeze(ChecklistItemCategory)
